import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  //附件下载
  const handleDownloadFile = listeners["handleDownloadFile"] || function() {};

  const AccountTableConfig = [
    {
      label: "转让角色",
      prop: "deptRoleName",
      width: "160",
      showOverflowTooltip: true
    },
    {
      label: "被转让用户",
      prop: "moveUserName",
      width: "100",
      render: vo => (
        <div>
          {vo.row.moveUserName}<br/>
          {vo.row.moveUserMobile}
        </div>
      )
    },
    {
      label: "证明材料",
      prop: "verifyName",
      showOverflowTooltip: true,
      width: "160",
      render: vo => (
        <el-button
          class="no-padding"
          size="small"
          type="text"
          onClick={() => handleDownloadFile(vo.row)}
        >
          {vo.row.verifyName}
        </el-button>
      )
    },
    {
      label: "申请时间",
      prop: "createDate",
      width: "160"
    },
    {
      label: "申请人",
      prop: "createUserName",
      width: "100",
      render: vo => (
        <div>
          {vo.row.createUserName}<br/>
          {vo.row.createUserMobile}
        </div>
      )
    },
    {
      label: "审核时间",
      prop: "auditDate",
      width: "150",
      render: vo => (
        <div>
          {vo.row.auditDate || '--'}
        </div>
      )
    },
    {
      label: "审核人",
      prop: "auditUserName"
    },
    {
      label: "审核意见",
      prop: "auditContent",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "审核状态",
      prop: "auditStatusName"
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
